import { findAncestorWithHelixType, HELIX_TYPE_LIST } from '../helixUtils';

export const listSearchEvent = (
    { listID, listType, listItemIndex, contentId },
    clickTarget = null,
    category,
    searchTerm
) => {
    return {
        name: 'svtplay-search-autocomplete-click',
        type: 'search',
        eventValues: {
            listID: `search-${category}`,
            listType: 'search',
            listItemIndex,
            listIndex: 1,
            contentId,
            searchTerm: searchTerm,
        },
    };
};

export const searchQueryEvent = (searchTerm) => {
    return {
        name: 'svtplay-search-query',
        type: 'search',
        eventValues: {
            searchTerm,
        },
    };
};

export const listTrackingEvent = (
    { listID, listType, listItemIndex, listExpandedState, contentId },
    clickTarget = null
) => {
    const list = findAncestorWithHelixType(clickTarget, HELIX_TYPE_LIST);
    const lists = document.querySelectorAll(`[data-helix-type="${HELIX_TYPE_LIST}"]`);

    const listIndex = Array.from(lists).indexOf(list);

    if (!listExpandedState && list) {
        const expandButton = list.querySelector('[data-rt="expand-button"]');

        if (expandButton) {
            listExpandedState = expandButton.getAttribute('aria-expanded') === 'true' ? 'expand' : 'collapse';
        }
    }

    return {
        name: 'svtplay-list-tracking',
        eventValues: {
            listID,
            listType,
            listItemIndex,
            listIndex: listIndex > -1 ? listIndex + 1 : -1,
            listExpandedState,
            contentId,
        },
    };
};

export const programGuideChangeDateEvent = (date) => ({
    name: 'svtplay-program-guide-change-date',
    eventValues: {
        date,
    },
});

export const programGuideViewChannelEvent = (channel) => ({
    name: 'svtplay-program-guide-view-channel',
    eventValues: {
        channel,
    },
});

export const programGuideExpandItem = (svtId, start, channel) => ({
    name: 'svtplay-program-guide-expand-item',
    eventValues: {
        svtId,
        start,
        channel,
    },
});

export const mainMenuItemClickEvent = (name, index) => ({
    name: 'svtplay-main-menu-item-click',
    eventValues: {
        name,
        index,
    },
});

export const highlightClickEvent = (svtId, name) => ({
    name: 'one-view-interaction',
    type: 'interaction',
    content: { id: svtId, type: 'video' },
    eventValues: {
        interactionComponent: 'highlights-list',
        highlightName: name,
    },
});

export const footerClickEvent = (name) => ({
    name: 'svtplay-footer-click',
    eventValues: {
        name,
    },
});

export const genreGridItemClickEvent = (genre) => ({
    name: 'svtplay-genre-grid-item-click',
    eventValues: {
        genre,
    },
});

export const languageSupportClick = (type) => ({
    name: 'svtplay-language-support-click',
    eventValues: {
        type,
    },
});

export const showMorePrograms = (channel) => ({
    name: 'svtplay-program-page-show-more',
    eventValues: {
        channel,
    },
});

export const programFilterClick = (filterName) => ({
    name: 'svtplay-program-page-filter',
    eventValues: {
        filterName,
    },
});

export const expandListClick = (eventData) => ({
    name: 'svtplay-expand-list',
    eventValues: {
        listId: eventData.listId,
        action: eventData.action,
    },
});

const setSetting = (name, key, value) => ({
    name,
    type: 'one-view-interaction',
    eventValues: {
        interactionComponent: 'settings',
        [key]: value ? 'on' : 'off',
    },
});

export const setAutoplayNext = (value) => setSetting('set-autoplay-next', 'autoplayNext', value);

export const setVideoCompatibilityMode = (value) =>
    setSetting('set-video-compatibility-mode', 'videoCompatibilityMode', value);

export const setContinueWatching = (value) => setSetting('set-continue-watching', 'continueWatching', value);

export const setEnhancedParentalLock = (value) =>
    setSetting('set-enhanced-parental-lock', 'enhancedParentalLock', value);
